// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Osdi6","mathEquation":"styles_mathEquation__mVCTM","fadeInOut":"styles_fadeInOut__SmosG","loader":"styles_loader__RolHt"};